import { useEffect, useState } from 'react';
const isCustomProperty = (color) => {
    return color === null || color === void 0 ? void 0 : color.startsWith('var(');
};
const getCustomPropertyValue = (color) => {
    const maybeColorArray = color.split(/[\s, (\s )]+/);
    const maybeColor = Array.isArray(maybeColorArray)
        ? maybeColorArray[1]
        : color;
    const computedStyle = getComputedStyle(document.documentElement).getPropertyValue(maybeColor);
    const fallbackColor = maybeColorArray.length === 4 ? maybeColorArray[2] : '#ffffff';
    return computedStyle.length > 0 ? computedStyle : fallbackColor;
};
const getColor = (color) => {
    return color && isCustomProperty(color)
        ? getCustomPropertyValue(color)
        : color;
};
export const useZdsColor = (color) => {
    const [transformedColor, setTransformedColor] = useState(color);
    useEffect(() => {
        setTransformedColor(getColor(color));
    }, [color]);
    return transformedColor;
};
//# sourceMappingURL=useZdsColor.js.map
// @zapier/design-system@6.14.1 (10126c41d)
